// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).process = { env: { DEBUG: undefined } };
